<template>
  <v-app-bar-nav-icon class="ml-0 ml-md-15 ml-lg-15 ml-xl-15">
    <img
      src="@/assets/default/logoplatform2.png"
      alt="Company Logo"
      style="width: 40px; height: 40px"
    />
  </v-app-bar-nav-icon>
</template>
